export default __webpack_public_path__ + "static/media/greenBulb.f8aaa789.svg";